
import makerjs from "makerjs";
function A32(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param, R = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       w = W * 1 * myZoom,
       r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;

       hd=Math.sqrt(r*r-(w/2*w/2)), hh=h-r+hd,
       x0 = 0, x1 = 0, x2 = w, x3 = w, y0 = 0, y1 = hh, y2 = hh, y3 = 0,glassH = h, glassW = w;

   if (h !== 0) {
       var TxtH = H;
   } if (r !== 0) {
    var TxtR = "R="+R;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA32 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "ArcLine": new makerjs.paths.Arc([x1,y1], [x2,y2], r, false, true),
        "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
        "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeA32MarkR = {
       paths: {
        "LeftLine": new makerjs.paths.Line([w/2, h], [w/2, h-r]),
        // "LeftShortUpline": new makerjs.paths.Line([x1, y1], [x0 - 2 * markShift, y1]),
        // "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeA32MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([x3+ markShift, y3], [x3+ markShift, y3+h]),
        "RightShortUpline": new makerjs.paths.Line([x3, y3+h], [x3+ 2 * markShift, y3+h]),
        "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeA32MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y3 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA32MarkW, TxtW, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字 
   makerjs.model.addCaption(drawAbnormalShapeA32MarkH, TxtH, [x3 + 2 * markShift, y3], [x3 + 2 * markShift, y3+h]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA32MarkR, TxtR, [w/2, h-r], [w/2+2*markShift, h-r]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA32: drawAbnormalShapeA32,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA32: drawAbnormalShapeA32,
        drawAbnormalShapeA32MarkR: drawAbnormalShapeA32MarkR,
        drawAbnormalShapeA32MarkH:drawAbnormalShapeA32MarkH,
        drawAbnormalShapeA32MarkW:drawAbnormalShapeA32MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A32;